import {
  RazorTable,
  RazorTableRow,
  RazorTextTrim,
} from "../../../components/razor-reuse";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import FilterReusableComp from "../../../components/FilterReusableComp";
import DotActionDropFragment from "../../../components/fragment/actionIconFragment/DotActionDropFragment";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import TextColorFragment from "../../../components/fragment/text-color/TextColorFragment";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import { getAllRolesDrop } from "../../../redux/role";
import RootState from "../../../redux/type";
import { getAllAdminUsersPaginated } from "../../../redux/users";
import "../../../styles/dashboard/users/UserIndex.css";
import { capitalizeFirstLetter, formatTime } from "../../../utils/Helper";
import ActivateUserModal from "./ActivateUserModal";
import AddNewUserModal from "./AddNewUserModal";
import DeactivateUserModal from "./DeactivateUserModal";
import EditUserModal from "./EditUserModal";
import ViewUserModal from "./ViewAdmiUserRole";
import ResendAdminUserModal from "./ResendInviteModal";
import { systemRoles } from "../../../utils/roles";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { useNavigate } from "react-router-dom";

const UserIndex = () => {
  const { all_roles_drop } = useSelector((state: RootState) => state.roles);
  const { loading, admin_users_paginated } = useSelector(
    (state: RootState) => state.users
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);

  const [singleChild, setSingleChild] = useState({});
  type modalProps = {
    add: boolean;
    edit: boolean;
    activate: boolean;
    deactivate: boolean;
    view: boolean;
    resend: boolean;
  };
  const [refreshTable, setRefreshTable] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<modalProps>({
    add: false,
    edit: false,
    deactivate: false,
    activate: false,
    view: false,
    resend: false,
  });
  const [filterOneVal, setFilterOneVal] = useState<any>("");

  const headerList = [
    "Full Name",
    "Email",
    "Role",
    "Status",
    "Date Created",
    "Action",
  ];

  const actionList = [
    {
      icon: ALL_ICONS?.view,
      label: "View",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal((prev) => {
          return { ...prev, view: true };
        });
      },
      textColor: "",
    },
    {
      icon: ALL_ICONS?.edit,
      label: "Edit",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal((prev) => {
          return { ...prev, edit: true };
        });
      },
      textColor: "",
      hide: !user?.permissions?.includes(systemRoles[18]),
    },
    {
      icon: ALL_ICONS?.resend_icon,
      label: "Resend Invite",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal((prev) => {
          return { ...prev, resend: true };
        });
      },
      textColor: "",
    },
    {
      icon: ALL_ICONS?.delete,
      label: "Delete",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal((prev) => {
          return { ...prev, deactivate: true };
        });
      },
      textColor: "rgba(225, 25, 0, 1)",
    },
    // {
    //   //   icon: ALL_ICONS?.delete,
    //   label: "Activate",
    //   onClick: (param?: any) => {
    //     setSingleChild(param);
    //     setShowModal((prev) => {
    //       return { ...prev, activate: true };
    //     });
    //   },
    //   textColor: "rgba(0, 153, 51, 1)",
    // },
  ];

  const updateActionArray = (
    hideObj?: any,
    hideObjTwo?: any,
    hideObjThree?: any,
    hideObjFour?: any
  ) => {
    const newList = actionList?.map((chi) => {
      return chi?.label === hideObj?.label
        ? { ...chi, hide: hideObj?.hide ? true : false }
        : { ...chi };
    });
    const secondList = newList?.map((chi) => {
      return chi?.label === hideObjTwo?.label
        ? { ...chi, hide: hideObjTwo?.hide ? true : false }
        : { ...chi };
    });
    const thirdList = secondList?.map((chi) => {
      return chi?.label === hideObjThree?.label
        ? { ...chi, hide: hideObjThree?.hide ? true : false }
        : { ...chi };
    });
    const fourthList = thirdList?.map((chi) => {
      return chi?.label === hideObjFour?.label
        ? { ...chi, hide: hideObjFour?.hide ? true : false }
        : { ...chi };
    });
    return fourthList;
  };

  const [currentPageVal, setCurrentPage] = useState(1);

  useEffect(() => {
    if (
      all_roles_drop?.length < 1 &&
      user?.permissions?.includes(systemRoles[23]) &&
      user?.permissions?.includes(systemRoles[17])
    ) {
      dispatch(getAllRolesDrop({}) as any);
    }
    const obj = {
      page: currentPageVal,
      search: "",
      roles: filterOneVal?.label,
    };
    if (user?.permissions?.includes(systemRoles[19])) {
      dispatch(getAllAdminUsersPaginated(obj) as any);
    }
  }, [refreshTable, currentPageVal, filterOneVal, user?.permissions]);

  // useEffect to check if user has permission to view transactions
  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[19]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, []);

  const handleFinish = () => {
    setShowModal({
      add: false,
      edit: false,
      deactivate: false,
      activate: false,
      view: false,
      resend: false,
    });
    setRefreshTable(!refreshTable);
  };

  function arrayToString(arr: string[], separator: string = ", "): string {
    return arr.join(separator);
  }

  const getListUserRole = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) =>
        capitalizeFirstLetter(chi?.name)?.replaceAll("_", " ")
      );

      return arrayToString(newList);
    }
  };

  const getListUserId = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => chi?.name);
      return newList;
    }
  };

  return (
    <>
      <DashboardLayoutMain
        loading={Object?.keys(admin_users_paginated)?.length < 1 && loading}
        title="Team Management"
      >
        <div className="user-index-smart-send-wrapper-all-users">
          <TitleBtnFragment
            onBtnClick={() => {
              setShowModal((prev) => {
                return { ...prev, add: true };
              });
            }}
            title=""
            btnLabel="Add Team Member"
            hideBtn={!user?.permissions?.includes(systemRoles[17])}
          />
          {/* title btn end */}
          {/* filter section start */}
          <FilterReusableComp
            defaultSelectOne="Filter by Role"
            // selectOneList={all_roles_drop}
            selectOneValue={filterOneVal}
            // hideFilter

            onSelectOne={(param) => {
              setFilterOneVal(param);
            }}
            onSearch={(param: any) => {
              if (String(param)?.length > 2) {
                const obj = {
                  search: param,
                };
                dispatch(getAllAdminUsersPaginated(obj) as any);
              }
              if (String(param)?.length < 1) {
                dispatch(getAllAdminUsersPaginated({}) as any);
              }
            }}
            hideExport
            searchPlaceholder="Search for users by email, full name"
          />
          {/* filter section end */}
          {/* table start */}
          <div className="table-section-box">
            <RazorTable headerList={headerList}>
              {admin_users_paginated?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    loading={loading}
                    key={idx}
                    one={RazorTextTrim(
                      `${capitalizeFirstLetter(chi?.first_name) || ""} ${
                        capitalizeFirstLetter(chi?.last_name) || ""
                      }`,
                      25
                    )}
                    two={RazorTextTrim(chi?.email, 30) || ""}
                    three={
                      chi?.roles?.length > 0
                        ? RazorTextTrim(getListUserRole(chi?.roles), 25)
                        : "---"
                    }
                    four={
                      <TextColorFragment
                        color={
                          chi?.status === "Active"
                            ? "rgba(0, 153, 51, 1)"
                            : chi?.status === "Pending"
                            ? "rgba(255, 192, 67, 1)"
                            : chi?.status === "Deactivated"
                            ? "rgba(200, 16, 46, 1)"
                            : ""
                        }
                        text={chi?.status}
                      />
                    }
                    onRowClick={() => {
                      setSingleChild(chi);
                      setShowModal((prev) => {
                        return { ...prev, view: true };
                      });
                    }}
                    five={formatTime(chi?.created_at)}
                    six={
                      <DotActionDropFragment
                        dropPosition={
                          idx >= admin_users_paginated?.data?.length - 3 &&
                          admin_users_paginated?.data?.length > 7
                            ? "top"
                            : "bottom"
                        }
                        list={updateActionArray(
                          {
                            hide: chi?.status === "Pending",
                            label: "Delete",
                          },
                          {
                            hide: chi?.status !== "Deactivated",
                            label: "Activate",
                          },
                          {
                            hide:
                              (getListUserId(chi?.roles)?.includes(
                                "super_admin"
                              ) &&
                                chi?.status !== "Pending") ||
                              !user?.permissions?.includes(systemRoles[20]),
                            label: "Delete",
                          },
                          {
                            hide: chi?.status !== "Pending",
                            label: "Resend Invite",
                          }
                        )}
                        detail={chi}
                      />
                    }
                  />
                );
              })}
            </RazorTable>
          </div>
          {/* table end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={admin_users_paginated?.meta?.current_page || 1}
            perPage={admin_users_paginated?.meta?.per_page}
            totalPage={admin_users_paginated?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading}
          />
          {/* pagination  end */}
        </div>
      </DashboardLayoutMain>
      {/* modal start */}
      <DeactivateUserModal
        visible={showModal?.deactivate}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, deactivate: false };
          });
        }}
        onFinish={handleFinish}
        details={singleChild}
      />
      <ActivateUserModal
        visible={showModal?.activate}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, activate: false };
          });
        }}
        details={singleChild}
      />
      <AddNewUserModal
        visible={showModal?.add}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, add: false };
          });
        }}
        onFinish={handleFinish}
      />
      <EditUserModal
        visible={showModal?.edit}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, edit: false };
          });
        }}
        onFinish={handleFinish}
        detail={singleChild}
      />
      <ViewUserModal
        visible={showModal?.view}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, view: false };
          });
        }}
        detail={singleChild}
      />
      <ResendAdminUserModal
        visible={showModal?.resend}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, resend: false };
          });
        }}
        details={singleChild}
      />
      {/* modal end */}
    </>
  );
};

export default UserIndex;
